'use client';

import useExpirationInfo from '~/hooks/flp-rsc/useExpirationInfo';
import { InventoryLineSkeleton } from '../../skeletons';

type OwnProps = {
  expiration: string;
  inventory: number;
};

export default function InventoryCountLine({
  expiration,
  inventory
}: OwnProps) {
  const { day, isLoading, isValidExpiration, month, suffix } =
    useExpirationInfo(expiration);

  if (isLoading) {
    return <InventoryLineSkeleton />;
  }

  if (!isValidExpiration) {
    return null;
  }

  return (
    <p>
      You’ve unlocked real terms on{' '}
      <strong>{Number(inventory).toLocaleString('en-US')}</strong> vehicles
      until{' '}
      <span
        className="t-strong-sm sm:t-strong-md"
        data-testid="expiration-date"
      >
        {month}&nbsp;{day}
        {suffix}
      </span>
      &#46;
    </p>
  );
}
